module.exports = __webpack_public_path__ + "img/profile.eacc326f.svg";